import { render } from "./PackagesAdults.vue?vue&type=template&id=23d55ff0&scoped=true"
import script from "./PackagesAdults.vue?vue&type=script&lang=js"
export * from "./PackagesAdults.vue?vue&type=script&lang=js"

import "./PackagesAdults.vue?vue&type=style&index=0&id=23d55ff0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d55ff0"]])

export default __exports__